export default {
    "address": "0x0Df0e93b0aFBBfF7c6cc3c005eFAf7d85C0eA71A",
    "abi":[
        {
            "type": "constructor",
            "inputs": [
                {
                    "name": "initialOwner",
                    "type": "address",
                    "internalType": "address"
                },
                {
                    "name": "_vault",
                    "type": "address",
                    "internalType": "contract IVault"
                }
            ],
            "stateMutability": "nonpayable"
        },
        {
            "type": "function",
            "name": "getAmountIn",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "zeroForOne",
                    "type": "bool",
                    "internalType": "bool"
                },
                {
                    "name": "amountOut",
                    "type": "uint256",
                    "internalType": "uint256"
                },
                {
                    "name": "dynamicFee",
                    "type": "bool",
                    "internalType": "bool"
                }
            ],
            "outputs": [
                {
                    "name": "amountIn",
                    "type": "uint256",
                    "internalType": "uint256"
                },
                {
                    "name": "fee",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "feeAmount",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getAmountOut",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "zeroForOne",
                    "type": "bool",
                    "internalType": "bool"
                },
                {
                    "name": "amountIn",
                    "type": "uint256",
                    "internalType": "uint256"
                },
                {
                    "name": "dynamicFee",
                    "type": "bool",
                    "internalType": "bool"
                }
            ],
            "outputs": [
                {
                    "name": "amountOut",
                    "type": "uint256",
                    "internalType": "uint256"
                },
                {
                    "name": "fee",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "feeAmount",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getBorrowAPR",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "borrowForOne",
                    "type": "bool",
                    "internalType": "bool"
                }
            ],
            "outputs": [
                {
                    "name": "rate",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getBorrowRate",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "marginForOne",
                    "type": "bool",
                    "internalType": "bool"
                }
            ],
            "outputs": [
                {
                    "name": "",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getLendingAPR",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "borrowForOne",
                    "type": "bool",
                    "internalType": "bool"
                },
                {
                    "name": "inputAmount",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "outputs": [
                {
                    "name": "apr",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getLiquidateRepayAmount",
            "inputs": [
                {
                    "name": "tokenId",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "outputs": [
                {
                    "name": "repayAmount",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getMaxDecrease",
            "inputs": [
                {
                    "name": "tokenId",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "outputs": [
                {
                    "name": "maxAmount",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getPoolFees",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                },
                {
                    "name": "zeroForOne",
                    "type": "bool",
                    "internalType": "bool"
                },
                {
                    "name": "amountIn",
                    "type": "uint256",
                    "internalType": "uint256"
                },
                {
                    "name": "amountOut",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "outputs": [
                {
                    "name": "_fee",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "_marginFee",
                    "type": "uint24",
                    "internalType": "uint24"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getPoolStateInfo",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                }
            ],
            "outputs": [
                {
                    "name": "stateInfo",
                    "type": "tuple",
                    "internalType": "struct LikwidHelper.PoolStateInfo",
                    "components": [
                        {
                            "name": "totalSupply",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "lastUpdated",
                            "type": "uint32",
                            "internalType": "uint32"
                        },
                        {
                            "name": "lpFee",
                            "type": "uint24",
                            "internalType": "uint24"
                        },
                        {
                            "name": "marginFee",
                            "type": "uint24",
                            "internalType": "uint24"
                        },
                        {
                            "name": "protocolFee",
                            "type": "uint24",
                            "internalType": "uint24"
                        },
                        {
                            "name": "realReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "realReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "mirrorReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "mirrorReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "pairReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "pairReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "truncatedReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "truncatedReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "lendReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "lendReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "interestReserve0",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "interestReserve1",
                            "type": "uint128",
                            "internalType": "uint128"
                        },
                        {
                            "name": "borrow0CumulativeLast",
                            "type": "uint256",
                            "internalType": "uint256"
                        },
                        {
                            "name": "borrow1CumulativeLast",
                            "type": "uint256",
                            "internalType": "uint256"
                        },
                        {
                            "name": "deposit0CumulativeLast",
                            "type": "uint256",
                            "internalType": "uint256"
                        },
                        {
                            "name": "deposit1CumulativeLast",
                            "type": "uint256",
                            "internalType": "uint256"
                        }
                    ]
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getReleasedLiquidity",
            "inputs": [
                {
                    "name": "id",
                    "type": "bytes32",
                    "internalType": "PoolId"
                }
            ],
            "outputs": [
                {
                    "name": "",
                    "type": "uint128",
                    "internalType": "uint128"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getStageLiquidities",
            "inputs": [
                {
                    "name": "poolId",
                    "type": "bytes32",
                    "internalType": "PoolId"
                }
            ],
            "outputs": [
                {
                    "name": "liquidities",
                    "type": "uint128[][]",
                    "internalType": "uint128[][]"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "getStageState",
            "inputs": [
                {
                    "name": "id",
                    "type": "bytes32",
                    "internalType": "PoolId"
                }
            ],
            "outputs": [
                {
                    "name": "stageSize",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "stageLeavePart",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "stageDuration",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "lastStageTimestamp",
                    "type": "uint256",
                    "internalType": "uint256"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "minMarginLevels",
            "inputs": [],
            "outputs": [
                {
                    "name": "minMarginLevel",
                    "type": "uint24",
                    "internalType": "uint24"
                },
                {
                    "name": "minBorrowLevel",
                    "type": "uint24",
                    "internalType": "uint24"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "owner",
            "inputs": [],
            "outputs": [
                {
                    "name": "",
                    "type": "address",
                    "internalType": "address"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "function",
            "name": "setVault",
            "inputs": [
                {
                    "name": "_vault",
                    "type": "address",
                    "internalType": "contract IVault"
                }
            ],
            "outputs": [],
            "stateMutability": "nonpayable"
        },
        {
            "type": "function",
            "name": "transferOwnership",
            "inputs": [
                {
                    "name": "newOwner",
                    "type": "address",
                    "internalType": "address"
                }
            ],
            "outputs": [],
            "stateMutability": "nonpayable"
        },
        {
            "type": "function",
            "name": "vault",
            "inputs": [],
            "outputs": [
                {
                    "name": "",
                    "type": "address",
                    "internalType": "contract IVault"
                }
            ],
            "stateMutability": "view"
        },
        {
            "type": "event",
            "name": "OwnershipTransferred",
            "inputs": [
                {
                    "name": "user",
                    "type": "address",
                    "indexed": true,
                    "internalType": "address"
                },
                {
                    "name": "newOwner",
                    "type": "address",
                    "indexed": true,
                    "internalType": "address"
                }
            ],
            "anonymous": false
        },
        {
            "type": "error",
            "name": "InvalidReserves",
            "inputs": []
        },
        {
            "type": "error",
            "name": "SafeCastOverflow",
            "inputs": []
        }
    ]
}